import { render, staticRenderFns } from "./ScoreScreen.vue?vue&type=template&id=60a97298&scoped=true&lang=pug&"
import script from "./ScoreScreen.vue?vue&type=script&lang=js&"
export * from "./ScoreScreen.vue?vue&type=script&lang=js&"
import style0 from "./ScoreScreen.vue?vue&type=style&index=0&id=60a97298&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a97298",
  null
  
)

export default component.exports